jQuery(function($) {
	$.polyfillMultiselects = function() {
		if($.supports.touch) return;

		$('select[multiple]').multiselect().on('focus blur reset', function(e) {
			$(this).parents('.pagecreator_formelement').eq(0).css('z-index', e.type === 'focus' ? 11 : '');

			if(e.type === 'reset') {
				$(this).next().find('.active').removeClass('active');
				setTimeout(function() {
					$(this).val('');
				}.bind(this), 10);
			}
		});
	};
	$.polyfillPlaceholders = polyfillPlaceholders;
});